import firebase from 'firebase';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Game from './components/Game';
import Lobby from './components/Lobby';
import { CreateRoom, EnterRoom, Room } from './components/Room';
import Round from './components/Round';
import { SvgPlayground } from 'components/SvgPlayground';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB_eMdeqbB7eupyyuKSsOuOUrNWQ_JsWDs",
  authDomain: "nua-oans-9fe75.firebaseapp.com",
  databaseURL: "https://nua-oans-9fe75.firebaseio.com",
  projectId: "nua-oans-9fe75",
  storageBucket: "nua-oans-9fe75.appspot.com",
  messagingSenderId: "591670151451",
  appId: "1:591670151451:web:2e3ee0e86883c71616ebbe",
  measurementId: "G-WLFT4FWNWJ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const App = () => {
  return (
    <CookiesProvider>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Router>
          <Switch>
            <Route exact path="/">
              <Lobby/>
            </Route>
            <Route exact path="/room/create">
              <CreateRoom/>
            </Route>
            <Route exact path="/room/enter/:roomId?">
              <EnterRoom/>
            </Route>
            <Route exact path="/room">
              <Room/>
            </Route>
            <Route exact path="/room/game/:gameId">
              <Game/>
            </Route>
            <Route exact path="/room/game/:gameId/round/:roundId">
              <Round/>
            </Route>
            <Route exact path="/svg">
              <SvgPlayground/>
            </Route>
          </Switch>
        </Router>
      </div>
    </CookiesProvider>
  );
};

export default App;
